import { checkKeyDown } from '../helper/keyDown';

/**
 * Mobile Navigation.
 *
 * Required to open and close the mobile navigation.
 */
export const mobileNav = () => {
	/**
	 * Menu Toggle Behaviors
	 *
	 * @param {string} id Navigation ID
	 */
	const navMenu = ( id ) => {
		const menuWrapperItem = '.menu-wrapper > li >';
		const selectors =
			menuWrapperItem +
			' input, ' +
			menuWrapperItem +
			' a, ' +
			menuWrapperItem +
			' button';
		const html = document.documentElement;
		const body = document.body;
		const toggleButton = document.getElementById( id + '-toggle-menu' );
		const modal = document.querySelector( '#header-' + id + '-menu' );
		let modalElements = modal.querySelectorAll( selectors );
		modalElements = Array.prototype.slice.call( modalElements );

		if ( toggleButton ) {
			toggleButton.onclick = () => {
				body.classList.toggle( id + '-navigation-open' );
				html.classList.toggle( 'lock-scrolling' );
				body.classList.toggle( 'lock-scrolling' );
				toggleButton.setAttribute(
					'aria-expanded',
					toggleButton.getAttribute( 'aria-expanded' ) === 'true'
						? 'false'
						: 'true'
				);

				// On open, move focus to the first item.
				if ( toggleButton.getAttribute( 'aria-expanded' ) === 'true' ) {
					modalElements[ 0 ].focus();
				}
			};
		}

		/**
		 * Trap keyboard navigation in the menu modal.
		 */
		document.addEventListener( 'keydown', function ( event ) {
			if ( ! body.classList.contains( id + '-navigation-open' ) ) {
				return;
			}

			const tabKey = checkKeyDown( event.key, 'Tab' );
			const shiftKey = event.shiftKey;
			const escKey = checkKeyDown( event.key, 'Escape' );
			const activeEl = document.activeElement; /* eslint-disable-line */
			const lastEl = modalElements[ modalElements.length - 1 ];
			const firstEl = modalElements[ 0 ];

			// Return focus to menu button and reset.
			if ( escKey ) {
				event.preventDefault();
				body.classList.remove(
					id + '-navigation-open',
					'lock-scrolling'
				);
				html.classList.remove( 'lock-scrolling' );
				toggleButton.focus();
			}

			// Move focus to first element.
			if (
				( ! shiftKey && tabKey && toggleButton === activeEl ) ||
				( ! shiftKey && tabKey && lastEl === activeEl )
			) {
				event.preventDefault();
				firstEl.focus();
			}

			// Return focus to last element.
			if ( shiftKey && tabKey && firstEl === activeEl ) {
				event.preventDefault();
				lastEl.focus();
			}

			// If there are no elements in the menu, don't move the focus
			if ( tabKey && firstEl === lastEl ) {
				event.preventDefault();
			}
		} );
	};

	window.addEventListener( 'load', () => {
		navMenu( 'primary' );
	} );
};
